import React from "react";

import  { Link } from "react-router-dom"

import "./aboutClassplus.css";

import mukulBhaswat from "../../assets/MB.png";

import BackBtn from "../../assets/backBtn.png";

import dashedHorizontal from "../../assets/dashedPattern.png"

const AboutClassplus = () => {
  return (
    <div className="about-container">
      <div className="about-heading">
      <Link to={'/homePage'}> <img className="backBtn" src={BackBtn} /></Link>
        <div className="heading-about">ABOUT CLASSPLUS</div>
      </div>

      <div className="about-section">
        <div className="about-left">
          <img src={mukulBhaswat} className="celebrityImage" />
        </div>

        <div className="about-right">
        
            Classplus is a Noida-based ed-tech company that has embarked on a
            mission to touch the lives of new-age content creators. We are set
            to revolutionize the content creation landscape globally by enabling
            content creators to monetize their skills.
            <br />
            <br />
            <br />
            Currently valued at 600 million dollars, We are a series-D funded
            market leader in the B2B segment helping creators build their own
            digital identities and empower their audience.
            <br />
            <br />
            <br />
            Want to know more about who we are and what we do? Join us on the
            17th, of April at Four Seasons, Worli. We’d love to talk to you over
            a cuppa tea.
            <br />
            <br />
            <br />
            See you there!
         
        </div>
      </div>
      <img src={dashedHorizontal} className="dashedHorizontal"/>
    </div>
  );
};

export default AboutClassplus;
